/**
 * Created by ZengFanHui on 18/05/04.
 */
export const SET_SUB_MENU_LIST = 'SET_SUB_MENU_LIST'

export const SET_SUB_MENU_WIDTH = 'SET_SUB_MENU_WIDTH'

export const SET_SUB_MENU_ACTIVE_NAME = 'SET_SUB_MENU_ACTIVE_NAME'

export const SET_TABS = 'SET_TABS'

export const SET_NEWTABS = 'SET_NEWTABS'

export const SET_MENU_ACTIVE_NAME = 'SET_MENU_ACTIVE_NAME'

export const SET_MENU_LIST = 'SET_MENU_LIST'

export const SET_TOGGLE_MENU_FROM_WHERE = 'SET_TOGGLE_MENU_FROM_WHERE'

export const SET_USERINFO = 'SET_USERINFO'

export const SET_ROLES = 'SET_ROLES'

export const SET_CURRENT_ROLES = 'SET_CURRENT_ROLES'
